// extracted by mini-css-extract-plugin
module.exports = {"TabButton":"TabButton_TabButton__2hzKC","Active":"TabButton_Active__3XHE0"};